//
// # GenAlphaSchema Namespace
//
// The schema lives in `current/`, one folder, never version-named. Only the
// depot holds several versions at once, so only its paths carry the version.
//
// `migrate.ts` says whether a migration is in flight; `registry.ts` records
// every version there has ever been.
//

export * from "./current";
export * as schema from "./current";

export * as registry from "./registry";
export * from "./migrate";
